import React, { useState } from "react";
import {
  ModalContent,
  ModalOverlay,
  IconDiv,
  ModalHeader,
  ModalText,
  StartButton,
} from "./Style";
import RocketIcon from "../../assets/rocket-icon.svg";
import OnboardingVideo from "../../assets/Aivoria AA (Onboarding video).mp4";
import Tour from "../Onboarding/Tour";

const OnboardModal = ({ onClose, setRunTour }) => {

  const handleStartTour = () => {
    setRunTour(true);
    onClose(); // Close the modal
  };

  return (
    <>
      <ModalOverlay>
        <ModalContent>
          <IconDiv>
            <img src={RocketIcon} alt="onboard" />
          </IconDiv>
          <div style={{ display: "flex", flexDirection: "column", gap: '0.75rem' }}>
            <ModalHeader>Welkom in Aivoria</ModalHeader>
            <ModalText>
              Laten we beginnen met een korte rondleiding door het platform en we zorgen ervoor dat je in no time aan de slag kunt.
            </ModalText>
          </div>
          <video
            src={OnboardingVideo}
            autoPlay
            loop
            muted
            playsInline
            controls
            style={{
              width: "100%",
              borderRadius: "0.75rem",
              objectFit: "cover",
              maxHeight: "20rem"
            }}
          />
          <StartButton onClick={handleStartTour}>Aan de slag</StartButton>
        </ModalContent>
      </ModalOverlay>
    </>
  );
};

export default OnboardModal;
